const app = angular.module('msi.shipping.select', [
  require('@ordergroove/brandy/src/app/addresses'),
  require('@ordergroove/brandy/src/app/toasts'),
  require('../modal')
]);

app.config(require('./state'));


module.exports = app.name;
